import generateTypes from '../utils/generateTypes';

export const GET_INTEGRATIONS = generateTypes('GET_INTEGRATIONS');
export const RESET_INTEGRATIONS = generateTypes('RESET_INTEGRATIONS');
